import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/vercel/path0/wowmall-shop/layouts/default.vue").then(m => m.default || m)),
  empty: defineAsyncComponent(() => import("/vercel/path0/wowmall-shop/layouts/empty.vue").then(m => m.default || m)),
  landing: defineAsyncComponent(() => import("/vercel/path0/wowmall-shop/layouts/landing.vue").then(m => m.default || m)),
  my: defineAsyncComponent(() => import("/vercel/path0/wowmall-shop/layouts/my.vue").then(m => m.default || m)),
  outside: defineAsyncComponent(() => import("/vercel/path0/wowmall-shop/layouts/outside.vue").then(m => m.default || m))
}